// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_41-1";
export var movingGradient = "_41-4";
export var movingGradientBlock = "_41-2";
export var skeleton = "_41-0";
export var skeletonText = "_41-3";